/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TaskBoxLightResponse } from './TaskBoxLightResponse';
import {
    TaskBoxLightResponseFromJSON,
    TaskBoxLightResponseFromJSONTyped,
    TaskBoxLightResponseToJSON,
    TaskBoxLightResponseToJSONTyped,
} from './TaskBoxLightResponse';

/**
 * Response light for get user attached of a taskbox
 * @export
 * @interface TaskBoxPersonsLightResponse
 */
export interface TaskBoxPersonsLightResponse {
    /**
     * 
     * @type {string}
     * @memberof TaskBoxPersonsLightResponse
     */
    id?: string;
    /**
     * The firstname of the doctor
     * @type {string}
     * @memberof TaskBoxPersonsLightResponse
     */
    firstname?: string;
    /**
     * The lastname of the doctor
     * @type {string}
     * @memberof TaskBoxPersonsLightResponse
     */
    lastname?: string;
    /**
     * 
     * @type {TaskBoxLightResponse}
     * @memberof TaskBoxPersonsLightResponse
     */
    taskboxLightResponse?: TaskBoxLightResponse;
    /**
     * Indicates whether the task is active
     * @type {boolean}
     * @memberof TaskBoxPersonsLightResponse
     */
    active?: boolean;
    /**
     * Indicates whether the current user is assigned to the task
     * @type {boolean}
     * @memberof TaskBoxPersonsLightResponse
     */
    isAssignee?: boolean;
    /**
     * Indicates whether the task is marked as favorite by the user.
     * @type {boolean}
     * @memberof TaskBoxPersonsLightResponse
     */
    isFavoriteAppUser?: boolean;
}

/**
 * Check if a given object implements the TaskBoxPersonsLightResponse interface.
 */
export function instanceOfTaskBoxPersonsLightResponse(value: object): value is TaskBoxPersonsLightResponse {
    return true;
}

export function TaskBoxPersonsLightResponseFromJSON(json: any): TaskBoxPersonsLightResponse {
    return TaskBoxPersonsLightResponseFromJSONTyped(json, false);
}

export function TaskBoxPersonsLightResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskBoxPersonsLightResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'firstname': json['firstname'] == null ? undefined : json['firstname'],
        'lastname': json['lastname'] == null ? undefined : json['lastname'],
        'taskboxLightResponse': json['taskboxLightResponse'] == null ? undefined : TaskBoxLightResponseFromJSON(json['taskboxLightResponse']),
        'active': json['active'] == null ? undefined : json['active'],
        'isAssignee': json['isAssignee'] == null ? undefined : json['isAssignee'],
        'isFavoriteAppUser': json['isFavoriteAppUser'] == null ? undefined : json['isFavoriteAppUser'],
    };
}

export function TaskBoxPersonsLightResponseToJSON(json: any): TaskBoxPersonsLightResponse {
    return TaskBoxPersonsLightResponseToJSONTyped(json, false);
}

export function TaskBoxPersonsLightResponseToJSONTyped(value?: TaskBoxPersonsLightResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'firstname': value['firstname'],
        'lastname': value['lastname'],
        'taskboxLightResponse': TaskBoxLightResponseToJSON(value['taskboxLightResponse']),
        'active': value['active'],
        'isAssignee': value['isAssignee'],
        'isFavoriteAppUser': value['isFavoriteAppUser'],
    };
}

